import jsPDF from 'jspdf';
import 'jspdf-autotable';

export const generateTransactionPDF = (transactions, filters, totals, userName) => {
  const doc = new jsPDF();
  
  // Title
  doc.setFontSize(20);
  doc.setTextColor(40, 40, 40);
  doc.text('Transaction Report', 105, 15, { align: 'center' });
  
  // User Info and Date
  doc.setFontSize(10);
  doc.setTextColor(100, 100, 100);
  doc.text(`Generated for: ${userName}`, 14, 25);
  doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 30);
  
  // Filters Info
  if (filters.dateRange) {
    doc.text(`Date Range: ${filters.dateRange}`, 14, 35);
  }
  if (filters.type && filters.type !== 'All') {
    doc.text(`Type: ${filters.type}`, 14, 40);
  }
  
  // Summary Section
  doc.setFontSize(12);
  doc.setTextColor(40, 40, 40);
  doc.text('Financial Summary', 14, 50);
  
  doc.setFontSize(10);
  doc.setTextColor(0, 100, 0);
  doc.text(`Total Income: Rs. ${formatCurrency(totals.income)}`, 14, 58);
  doc.setTextColor(200, 0, 0);
  doc.text(`Total Expense: Rs. ${formatCurrency(totals.expense)}`, 14, 64);
  doc.setTextColor(0, 0, 150);
  doc.text(`Balance: Rs. ${formatCurrency(totals.balance)}`, 14, 70);
  
  // Transactions Table
  const tableColumn = ['Name', 'Date', 'Type', 'Category', 'Amount', 'Status'];
  const tableRows = [];
  
  transactions.forEach(transaction => {
    const transactionData = [
      transaction.name,
      new Date(transaction.date).toLocaleDateString(),
      transaction.type,
      transaction.category,
      `Rs. ${formatCurrency(transaction.amount)}`,
      transaction.status
    ];
    tableRows.push(transactionData);
  });
  
  // Add table to PDF
  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
    startY: 80,
    styles: { fontSize: 8 },
    headStyles: { fillColor: [74, 113, 240] },
    alternateRowStyles: { fillColor: [240, 240, 240] },
    columnStyles: {
      0: { cellWidth: 30 },
      1: { cellWidth: 25 },
      2: { cellWidth: 20 },
      3: { cellWidth: 25 },
      4: { cellWidth: 25 },
      5: { cellWidth: 20 }
    }
  });
  
  // Footer
  const finalY = doc.lastAutoTable.finalY + 10;
  doc.setFontSize(8);
  doc.setTextColor(150, 150, 150);
  doc.text('Generated by Finance Tracker App', 105, finalY, { align: 'center' });
  
  return doc;
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};